import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../utils/supabaseClient';
import LoadingSpinner from './LoadingSpinner';

export const AdminGuard: React.FC = () => {
    const { user, loading } = useAuth();
    const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

    useEffect(() => {
        const checkAdminStatus = async () => {
            if (!user || !user.email) {
                setIsAdmin(false);
                return;
            }

            // Strict check: Only allow the specific admin email
            // Get the admin email from environment variables for security
            const allowedAdminEmail = import.meta.env.VITE_ADMIN_EMAIL;

            if (allowedAdminEmail && user.email?.toLowerCase() === allowedAdminEmail.toLowerCase()) {
                setIsAdmin(true);
            } else {
                console.warn(`Access denied for ${user.email}. Expected: ${allowedAdminEmail ? 'Configured Admin' : 'Not Configured'}`);
                setIsAdmin(false);
            }
        };

        if (!loading) {
            checkAdminStatus();
        }
    }, [user, loading]);

    if (loading || isAdmin === null) {
        return <LoadingSpinner />;
    }

    if (!isAdmin) {
        return <Navigate to="/dashboard" replace />;
    }

    return <Outlet />;
};

export default AdminGuard;
